
/* eslint-disable */
import React, { useContext, useEffect, useState } from "react";
// import { withRouter } from "react-router-dom";
import _ from "lodash";
// import { connect } from "react-redux";
import withForm from "modules/common/hoc/withForm";
import Modal from "modules/common/components/Modal";
import useFormValidator from "useFormValidator";
import { reactSelectCustomStyleCms, ucwords } from "helper";
import NumberFormat from 'react-number-format';
import PropTypes from "prop-types";
import { ModalContext } from "App";
// import * as actions from "../../../../actions";
// import * as c from "../../../../constants";

import {
  InputTemplate,
  RadioButtonTemplate,
} from "../../../common/components/inputComponents";

function UpdateBusinessActivity({
  formData,
  setFormData,
  // initialActivityValidateForm,
  // initialActivityFormData,
  // setInitialinitialActivityFormData,
  itemId,
  data,
  // necessaryFieldsList,
  // getNecessaryFieldsList,
  toggleInitialActivityUpdate,
  setToggleInitialActivityUpdate,
}) {
  const [formUpdate, setFormUpdate] = useState(data);
  // const [formDetails, setFormDetails] = useState(data.details)


  const validateUpdateForm = useFormValidator(formUpdate, {
    line_of_business: 'required',
    capital_amount: 'required',
    non_essential_gross_amount: 'required',
    essential_gross_amount: 'required',
  });

  // useEffect(() => {
  //   validateUpdateForm.validate()
  // }, [Object.values(formUpdate).join(',')])

  const setModal = useContext(ModalContext);

  const onUpdateBusinessActivity = (e) => {
    setFormUpdate({
      ...formUpdate,
      [e.target.name]: e.target.value,
    });
  };

  // update details field for resubmit
  // const onChangeDetails = (key) => (e) => {
  //   setFormDetails(prevDetail => ({
  //     ...prevDetail,
  //     [key]: e.target.value,
  //   }));
  // }

  // const onSelectDetails = (key) => (e) => {
  //   setFormDetails(prevDetail => ({
  //     ...prevDetail,
  //     [key]: e.value,
  //   }));
  // }  

  const closeModal = (e) => {
    e.preventDefault();
    // setModal({ isOpen: false });
    setToggleInitialActivityUpdate(false)
  };

  const onHandleSubmitUpdate = () => {
    // const arr = []
    // arr.push(formData.activities)

    setFormData({
      ...formData,
      // activities: [formData.activities[itemId] ? formUpdate : formData.activities]
      initial_activities: [
        ...formData.initial_activities.map((item, index) =>
          index === itemId ? formUpdate : item
        ),
      ],
    });
    // setModal({ isOpen: false });
    setToggleInitialActivityUpdate(false)
  };

  // const selectOptions = list => {
  //   const newList = [];

  //   if (_.isEmpty(list)) return false

  //   list.map(data => {
  //     return newList.push({
  //       label: ucwords(_.get(data, 'multiplier'))
  //         .replace(/_/g, ' ')
  //         .replace(/^(.)|\s+(.)/g, x => x.toUpperCase()),
  //       value: data.multiplier,
  //     });
  //   });
  //   return newList;
  // };

  // useEffect(() => {
  //   setFormUpdate(prevUpdate => ({
  //     ...prevUpdate,
  //     details: formDetails,
  //   }))
  // }, [formDetails, _.get(formUpdate, "details")])

  // useEffect(() => {
  //   if(_.get(formUpdate, "business_line_id")) {
  //     const args = { business_line_id: _.get(formUpdate, "business_line_id")}
  //     getNecessaryFieldsList(args)
  //   }
  // }, [_.get(formUpdate, "business_line_id")])

  //toggleInitialActivityUpdate 
  return (
    <Modal.Body className="py-4 update-business-activity-container">
      <h3 className="font-weight-bolder my-2 cms-text-primary">Update Activity</h3>
      {/* Business Activity Field */}
      <div className="form-input-group">
        <div className="form-row">
          {/* content */}
          <InputTemplate
            title="Line of Business"
            htmlFor="line_of_business"
            formValidatorMsg={validateUpdateForm.renderMessage("line_of_business")}
            containerClassName="col-sm-12 col-md-6"
            // Input component props
            // required
            placeholder="_"
            className="form-control text-uppercase my-2"
            style={{ outline: "none", borderRadius: "7px" }}
            type="text"
            autoComplete="none"
            // disabled={!_.get(formUpdate, "business_line_id") ? false : true}
            name="line_of_business"
            id={`line_of_business_${itemId}`}
            onChange={onUpdateBusinessActivity}
            value={_.get(formUpdate, "line_of_business") || ""}
          />
          <InputTemplate
            title="Capital Investment"
            htmlFor="capital_amount"
            formValidatorMsg={validateUpdateForm.renderMessage("capital_amount")}
            containerClassName="col-sm-12 col-md-6"
            // Input component props
            // required
            withCustomInputComponent={() => (
              <NumberFormat
                name="capital_amount"
                id={`capital_amount_${itemId}`}
                style={{ outline: "none", borderRadius: "7px" }}
                placeholder="_"
                allowLeadingZeros={true}
                className="form-control text-uppercase my-2"
                onValueChange={(values) => {
                  // const { formattedValue, value } = values;
                  const { floatValue } = values;

                  setFormUpdate((formUpdate) => ({
                    ...formUpdate,
                    capital_amount: floatValue,
                  }));
                }}
                displayType="input"
                thousandSeparator={true}
                isNumericString={true}
                prefix="" 
                value={_.get(formUpdate, "capital_amount")?.toString() || '0'}
              />
            )}
          /> 
          <InputTemplate
            title="Gross Receipt (Non-Essential)"
            htmlFor="non_essential_gross_amount"
            formValidatorMsg={validateUpdateForm.renderMessage("non_essential_gross_amount")}
            containerClassName="col-sm-12 col-md-6"
            // Input component props
            // required
            withCustomInputComponent={() => (
              <NumberFormat
                name="non_essential_gross_amount"
                id={`non_essential_gross_amount_${itemId}`}
                style={{ outline: "none", borderRadius: "7px" }}
                placeholder="_"
                allowLeadingZeros={true}
                className="form-control text-uppercase my-2"
                onValueChange={(values) => {
                  // const { formattedValue, value } = values;
                  const { floatValue } = values;

                  setFormUpdate((formUpdate) => ({
                    ...formUpdate,
                    non_essential_gross_amount: floatValue,
                  }));
                }}
                displayType="input"
                thousandSeparator={true}
                isNumericString={true}
                prefix="" 
                value={_.get(formUpdate, "non_essential_gross_amount")?.toString() || "0"}
              />
            )}
          />
          <InputTemplate
            title="Gross Receipt (Essential)"
            htmlFor="essential_gross_amount"
            formValidatorMsg={validateUpdateForm.renderMessage("essential_gross_amount")}
            containerClassName="col-sm-12 col-md-6"
            // Input component props
            // required
            withCustomInputComponent={() => (
              <NumberFormat
                name="essential_gross_amount"
                id={`essential_gross_amoun_${itemId}`}
                style={{ outline: "none", borderRadius: "7px" }}
                placeholder="_"
                allowLeadingZeros={true}
                className="form-control text-uppercase my-2"
                onValueChange={(values) => {
                  // const { formattedValue, value } = values;
                  const { floatValue } = values;

                  setFormUpdate((formUpdate) => ({
                    ...formUpdate,
                    essential_gross_amount: floatValue,
                  }));
                }}
                displayType="input"
                thousandSeparator={true}
                isNumericString={true}
                prefix="" 
                value={_.get(formUpdate, "essential_gross_amount")?.toString() || "0"}
              />
            )}
          />
        </div>
      </div>
      {/* buttons */}
      <div className="d-flex justify-content-end mr-4">
        <button
          disabled={!validateUpdateForm.response.is_passed}
          onClick={onHandleSubmitUpdate}
          type="button"
          className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary mr-3"
        >
          <span className="font-weight-bold text-light">
            {/* {creating ? <i className="fa fa-spin fa-spinner" /> : `Submit`} */}
            Update
          </span>{" "}
        </button>
        <button
          // disabled={creating}
          type="button"
          onClick={closeModal}
          className="mt-3 btn btn-dark "
        >
          <span className="font-weight-bold">Cancel</span>
        </button>
      </div>
    </Modal.Body>
  );
}

UpdateBusinessActivity.defaultProps = {
  UpdateBusinessActivity: false,
}

UpdateBusinessActivity.propTypes = {
  itemId: PropTypes.number.isRequired,
  data: PropTypes.instanceOf(Object).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired, 
  toggleInitialActivityUpdate: PropTypes.bool,
  setToggleInitialActivityUpdate: PropTypes.instanceOf(Function).isRequired, 
  
  // initialActivityFormData: PropTypes.instanceOf(Object).isRequired,
  // setInitialinitialActivityFormData: PropTypes.instanceOf(Function).isRequired,
  // getNecessaryFieldsList: PropTypes.instanceOf(Function),
  // necessaryFieldsList: PropTypes.instanceOf(Array).isRequired,
};

// const mapStateToProps = ({ api }) => ({
//   necessaryFieldsList: _.get(api, `${c.GET_NECESSARY_FIELD_LIST}.list`) || [],
// });
// const mapStateToProps = ({}) => ({
//   necessaryFieldsList: _.get(api, `${c.GET_NECESSARY_FIELD_LIST}.list`) || [],
// });

// const enhance = _.flowRight([
//   withRouter,
//   connect(mapStateToProps, {}),
// ]);

// export default enhance(UpdateBusinessActivity);

export default UpdateBusinessActivity;
